import { Component, Input, OnInit, ChangeDetectorRef } from '@angular/core';
import {
    FormInputComponent,
    InputComponentConfig,
    DataService,
    NotificationService,
} from '@vendure/admin-ui/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {
    VariantWithQuantityArgPayload,
    VariantWithQuantity,
} from './helpers/types';

@Component({
    standalone: true,
    selector: 'mandatory-variants-form-input',
    imports: [CommonModule, ReactiveFormsModule, FormsModule],
    template: `
        <div class="container" *ngFor="let variant of variants">
            <div>
                <div *ngIf="variant.featuredAsset">
                    <img
                        [src]="variant.featuredAsset.source"
                        alt="Product Variant"
                        width="20"
                    />
                </div>
                <div class="informations">
                    <span>ID: {{ variant.id }}</span>
                    <span>SKU: {{ variant.sku }}</span>
                </div>
            </div>
            <span>Mínima quantidade permitida: {{ variant.minQuantity }}</span>

            <div *ngIf="variant.maxQuantity">
                <br />
                <span
                    >Máxima quantidade permitida:
                    {{ variant.maxQuantity }}</span
                >
            </div>
        </div>
    `,
    styles: [
        `
            img {
                width: 20%;
            }

            .informations {
                display: flex;
                flex-direction: column;
                justify-content: center;
            }

            .container {
                margin-bottom: 30px;
            }

            .custom-button {
                margin-left: 20px;
            }
        `,
    ],
})
export class MandatoryVariantsFormInput
    implements FormInputComponent<InputComponentConfig>, OnInit
{
    @Input() readonly: boolean = false;
    @Input() formControl!: FormControl;
    @Input() config!: InputComponentConfig;

    variants: VariantWithQuantity[] = [];

    constructor(
        private dataService: DataService,
        private notificationService: NotificationService,
        private cd: ChangeDetectorRef
    ) {}

    ngOnInit(): void {
        this.searchVariantByIds();
    }

    searchVariantByIds(): void {
        const data: VariantWithQuantityArgPayload[] = this.formControl.value;

        const variantIds = data.map((item) => item.variantId.toString());
        this.dataService.product
            .getProductVariants({
                filter: { id: { in: variantIds } },
            })
            .mapStream((response) => response.productVariants.items)
            .subscribe({
                next: (variants) => {
                    this.variants = variants.map((variant) => {
                        const quantity = data.find(
                            (v) => v.variantId === variant.id
                        );

                        return {
                            ...variant,
                            minQuantity: quantity?.minQuantity || 0,
                            ...(quantity?.maxQuantity
                                ? { maxQuantity: quantity?.maxQuantity }
                                : {}),
                        };
                    });

                    this.cd.detectChanges();
                },
                error: (err) => {
                    this.notificationService.error(
                        'Erro ao buscar variantes: ',
                        err
                    );
                },
            });
    }
}
